import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CTA = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-cream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="relative overflow-hidden bg-cta-panel text-white p-10 lg:p-16 shadow-float"
          style={{ borderRadius: '2rem' }}
        >
          <div
            className="absolute top-0 right-0 w-64 h-64 bg-white/5 blur-3xl"
            style={{ borderRadius: '50%' }}
            aria-hidden
          />
          <div
            className="absolute bottom-0 left-0 w-48 h-48 bg-coral/20 blur-3xl"
            style={{ borderRadius: '50%' }}
            aria-hidden
          />

          <div className="relative max-w-3xl mx-auto text-center">
            <span
              className="inline-block bg-white/10 border border-white/20 px-4 py-1.5 text-white text-sm font-semibold mb-6"
              style={{ borderRadius: '999px' }}
            >
              {t.cta.badge}
            </span>

            <h2 className="text-4xl lg:text-5xl font-extrabold font-heading leading-[1.1] mb-6 text-balance">
              {t.cta.title}{' '}
              <span className="block sm:inline font-accent italic font-normal text-coral-light">
                {t.cta.titleSub}
              </span>
            </h2>

            <p className="text-lg text-white/85 max-w-xl mx-auto mb-10 leading-relaxed">{t.cta.body}</p>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-10">
              {t.cta.perks.map((perk) => (
                <div key={perk} className="flex items-center gap-2 text-white/90 text-sm">
                  <span
                    className="w-5 h-5 bg-white/15 border border-white/25 flex items-center justify-center shrink-0"
                    style={{ borderRadius: '50%' }}
                  >
                    <Check className="w-3 h-3 text-white" strokeWidth={3} />
                  </span>
                  <span>{perk}</span>
                </div>
              ))}
            </div>

            <a
              href="/s"
              className="inline-flex items-center gap-3 bg-coral hover:bg-coral-light text-white px-10 py-5 font-extrabold text-lg transition-all shadow-soft hover:-translate-y-1"
              style={{ borderRadius: '14px' }}
            >
              {t.cta.button}
              <ArrowRight className="w-6 h-6" />
            </a>

            <div className="mt-8 space-y-2">
              <p className="text-white font-semibold text-sm">{t.cta.priceLine}</p>
              <p className="text-white/75 text-sm">{t.cta.helpLine}</p>
            </div>

            <div
              className="mt-8 max-w-2xl mx-auto bg-ink/20 p-5 border border-white/10"
              style={{ borderRadius: '12px' }}
            >
              <p className="text-white/70 text-xs leading-relaxed text-left">{t.cta.legalBox}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
